
import { useState, useEffect, useRef } from 'react';
import AnimatedText from '../../../components/base/AnimatedText';

const castMembers = [
  {
    id: 1,
    name: '春夏冬 旬',
    role: 'アキナイ シュン',
    images: [
      'https://www.star-guys.jp/uploads/host/202509/300/20250917120321_508615_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314184845_849289_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314184906_70311_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314184928_321444_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185018_434400_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185030_607879_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185042_488579_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185053_550143_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185138_879928_1.jpg'
    ]
  },
  {
    id: 2,
    name: '如月 奏琉斗',
    role: 'キサラギ ソルト',
    images: [
      'https://www.star-guys.jp/uploads/host/202509/300/20250917121146_551681_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202509/300/20250917121137_272419_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202412/300/20241216151025_458358_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202408/300/20240820194742_816777_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202409/300/20240904183922_956478_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202409/300/20240904183936_955141_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202408/300/20240806165429_122409_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202407/300/20240702185219_830303_1.jpg'
    ]
  },
  {
    id: 'ren',
    name: '廉',
    age: 22,
    height: '175cm',
    bloodType: 'A型',
    hobby: 'ゲーム',
    comment: 'よろしくお願いします',
    images: [
      'https://www.star-guys.jp/uploads/host/202509/300/20250919104629_383230_1.jpg'
    ],
    isNew: false,
    isPopular: false
  },
  {
    id: 3,
    name: '姫乃 皇',
    role: 'ヒメノ コウ',
    images: [
      'https://www.star-guys.jp/uploads/host/202505/300/20250523144641_722801_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202412/300/20241219095455_411651_1.jpg'
    ]
  },
  {
    id: 'keita',
    name: '三木 京大',
    age: 23,
    height: '173cm',
    bloodType: 'O型',
    hobby: '寝る事',
    comment: '初回指名お待ちしています! 楽しませる自身はあります!!',
    images: [
      'https://www.star-guys.jp/uploads/host/202412/300/20241218174423_555467_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202412/300/20241218174416_95334_1.jpg'
    ],
    isNew: false,
    isPopular: false
  },
  {
    id: 'rui',
    name: '琉衣',
    age: 24,
    height: '173cm',
    bloodType: 'A型',
    hobby: '秘密',
    comment: 'よろしくお願いします',
    images: [
      'https://www.star-guys.jp/uploads/host/202503/300/20250314185528_885513_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185606_224951_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185616_320330_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185629_651548_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202503/300/20250314185639_717776_1.jpg'
    ],
    isNew: false,
    isPopular: true
  },
  {
    id: 'rin',
    name: '凛',
    age: 25,
    height: '177cm',
    bloodType: 'O型',
    hobby: 'アニメ鑑賞',
    comment: '会いにおいで。',
    images: [
      'https://www.star-guys.jp/uploads/host/202503/300/20250314190205_720338_1.jpg'
    ],
    isNew: false,
    isPopular: false
  },
  {
    id: 'kazuma',
    name: '上条 壱馬',
    age: 24,
    height: '175cm',
    bloodType: 'O型',
    hobby: 'ゴルフ',
    comment: '来たお客様に満足して帰っていただけるように精一杯頑張りますので指名たくさんお待ちしております',
    images: [
      'https://www.star-guys.jp/uploads/host/202506/300/20250628100153_440692_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202504/300/20250422103613_716976_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202305/300/20230513025755_550521_1.jpg'
    ],
    isNew: false,
    isPopular: true
  },
  {
    id: 'yuki',
    name: 'ゆき',
    age: 23,
    height: '172cm',
    bloodType: 'AB型',
    hobby: '筋トレ、バイク',
    comment: '筋肉×顔=俺',
    images: [
      'https://www.star-guys.jp/uploads/host/202509/300/20250917120518_803233_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202508/300/20250804124345_863319_1.jpg'
    ],
    isNew: false,
    isPopular: false
  },
  {
    id: 'ryu',
    name: '四川 流',
    age: 22,
    height: '162cm',
    bloodType: 'A型',
    hobby: '旅行先調べ',
    comment: '全力で楽しませます!',
    images: [
      'https://www.star-guys.jp/uploads/host/202509/300/20250918180449_854311_1.jpg'
    ],
    isNew: false,
    isPopular: false
  },
  {
    id: 'souma',
    name: '七瀬 蒼真',
    age: 25,
    height: '173cm',
    bloodType: 'A型',
    hobby: 'ギター、映画、キャンプ',
    comment: 'ATENAでまってるよー',
    images: [
      'https://www.star-guys.jp/uploads/host/202507/300/20250723104017_335573_1.jpg'
    ],
    isNew: false,
    isPopular: false
  },
  {
    id: 'kira',
    name: 'キラ',
    age: 26,
    height: '172cm',
    bloodType: 'O型',
    hobby: '旅行',
    comment: '神戸大好きで東京から引っ越して来ましたキラです!キラ神戸第二章一緒に作ってくれるお姫様待ってます!',
    images: [
      'https://www.star-guys.jp/uploads/host/202506/300/20250625214748_279335_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202505/300/20250509110235_754523_1.jpg',
      'https://www.star-guys.jp/uploads/hostsub/202505/300/20250505184756_580064_1.jpg'
    ],
    isNew: false,
    isPopular: true
  },
  {
    id: 'kanata',
    name: 'カナタ',
    age: 21,
    height: '169cm',
    bloodType: 'O型',
    hobby: 'アニメ、漫画、ゲーム、ぼーっとすること',
    comment: 'ホスト初心者です おてやわらかお願いしてます',
    images: [
      'https://www.star-guys.jp/uploads/host/202508/300/20250804124315_739557_1.jpg'
    ],
    isNew: true,
    isPopular: false
  },
  {
    id: 'nagi',
    name: '蘇芳 凪',
    age: 20,
    height: '172cm',
    bloodType: 'A型',
    hobby: 'バレーボール・邦ロック',
    comment: '初ホストなので分からないことだらけですが、一緒に頑張ってくれたら嬉しいなと思います!',
    images: [
      'https://www.star-guys.jp/uploads/host/202508/300/20250828102253_705438_1.jpg'
    ],
    isNew: true,
    isPopular: false
  },
  {
    id: 'towa',
    name: '永遠',
    age: 21,
    height: '170cm',
    bloodType: 'O型',
    hobby: '読書',
    comment: 'よろしくお願いします',
    images: [
      'https://www.star-guys.jp/uploads/host/202509/300/20250917121113_564997_1.jpg'
    ],
    isNew: true,
    isPopular: false
  },
  {
    id: 'rei',
    name: '楓 レイ',
    age: 24,
    height: '175cm',
    bloodType: 'B型',
    hobby: '音楽鑑賞',
    comment: 'よろしくお願いします',
    images: [
      'https://www.star-guys.jp/uploads/host/202408/300/20240826175404_312546_1.jpg'
    ],
    isNew: false,
    isPopular: false
  }
];

interface CastCardProps {
  cast: typeof castMembers[0];
  index: number;
  isVisible: boolean;
}

function CastCard({ cast, index, isVisible }: CastCardProps) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (cast.images.length > 1 && isHovered) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prev) => (prev + 1) % cast.images.length);
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [cast.images.length, isHovered]);

  const nextImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev + 1) % cast.images.length);
  };

  const prevImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev - 1 + cast.images.length) % cast.images.length);
  };

  return (
    <div
      className={`relative group cursor-pointer transform transition-all duration-700 ${
        isVisible 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: `${index * 150}ms` }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative overflow-hidden rounded-lg bg-gray-900">
        <div className="relative h-96">
          <img
            src={cast.images[currentImageIndex]}
            alt={cast.name}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          />
          
          {/* 複数画像がある場合のナビゲーション */}
          {cast.images.length > 1 && (
            <>
              <button
                onClick={prevImage}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10"
              >
                <i className="ri-arrow-left-line text-sm"></i>
              </button>
              <button
                onClick={nextImage}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10"
              >
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
              
              {/* 画像インジケーター */}
              <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {cast.images.map((_, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`w-2 h-2 rounded-full transition-colors duration-300 ${
                      currentImageIndex === imgIndex ? 'bg-white' : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
        
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80"></div>
        
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <h3 className="text-2xl font-bold">{cast.name}</h3>
        </div>
      </div>
    </div>
  );
}

export default function CastSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const carouselRef = useRef<HTMLDivElement>(null);

  const itemsPerView = 4;
  const totalSlides = Math.ceil(castMembers.length / itemsPerView);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section id="cast" className="py-20 pt-32 bg-black" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <AnimatedText
            text="キャスト"
            className="text-4xl font-bold text-white mb-4"
          />
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <AnimatedText
            text="魅力あふれるキャストがお客様をお迎えいたします"
            className="text-xl text-gray-300"
            delay={300}
          />
        </div>

        <div className="relative">
          {/* カルーセルコンテナ */}
          <div className="overflow-hidden" ref={carouselRef}>
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                <div key={slideIndex} className="w-full flex-shrink-0">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                    {castMembers
                      .slice(slideIndex * itemsPerView, (slideIndex + 1) * itemsPerView)
                      .map((cast, index) => (
                        <CastCard
                          key={slideIndex * itemsPerView + index}
                          cast={cast}
                          index={index}
                          isVisible={isVisible}
                        />
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ナビゲーションボタン */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-all duration-300 backdrop-blur-sm z-20"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-all duration-300 backdrop-blur-sm z-20"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          {/* インジケーター */}
          <div className="flex justify-center mt-8 space-x-2">
            {Array.from({ length: totalSlides }).map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  currentIndex === index 
                    ? 'bg-blue-500 scale-125' 
                    : 'bg-gray-600 hover:bg-gray-500'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
